import React from "react";
import { ThumbnailContent } from "./ThumbnailContent";
import { MediaItem } from "@/types/media";
import { useMediaItemWithProgress } from "@/hooks/useMediaItemWithProgress";

interface ThumbnailContentWithProgressProps
    extends Omit<
        React.ComponentProps<typeof ThumbnailContent>,
        "uploadProgress" | "uploadPhaseText"
    > {
    mediaItem: MediaItem;
}

/**
 * Wrapper around ThumbnailContent that automatically pulls fresh progress data from the store.
 * Use this component when rendering thumbnails during upload/processing to show progress bars.
 */
export const ThumbnailContentWithProgress: React.FC<ThumbnailContentWithProgressProps> = ({
    mediaItem,
    ...thumbnailProps
}) => {
    const freshMediaItem = useMediaItemWithProgress(mediaItem);

    return (
        <ThumbnailContent
            {...thumbnailProps}
            uploadProgress={freshMediaItem.progress}
            uploadPhaseText={freshMediaItem.uploadPhaseText}
        />
    );
};
